var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({},'img',{src: _vm._src, srcset: _vm.srcSet},false))}
var staticRenderFns = []

export { render, staticRenderFns }